import Vue from 'vue';
import CommonIcon from '@/components/CommonIcon.vue';
import BaseButton from '@/components/BaseButton.vue';
import BaseLink from '@/components/BaseLink.vue';
import BaseBookmark from '@/components/BaseBookmark.vue';
import BaseRequestIndicator from '@/components/BaseRequestIndicator.vue';
import setApiStoreBridge from '@/api/rest/base/storeBridge';
import push from '@/plugins/push';
import popup from '@/plugins/popup';
import App from './App.vue';
import router from './router';
import store from './store';

import '@/assets/styles/main.scss';

setApiStoreBridge();

Vue.component('Icon', CommonIcon);
Vue.component('Btn', BaseButton);
Vue.component('Link', BaseLink);
Vue.component('Bookmark', BaseBookmark);
Vue.component('RequestIndicator', BaseRequestIndicator);

Vue.config.productionTip = false;

Vue.use(push);
Vue.use(popup);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
